import {
  DOWNLOAD_PROVISION_EXCEL,
  FETCH_ADVANCE_DATA,
  FETCH_PROVISION_DATA,
} from '../endpoints/apiEndpoints'
import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

export const getknockOffData = async (payload) => {
  const url = urlBuilder(FETCH_PROVISION_DATA)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadKnockOffExcel = async (payload) => {
  const url = urlBuilder(DOWNLOAD_PROVISION_EXCEL)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

